import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './game-sdk';

import dotenv from 'dotenv';
import Phaser from 'phaser';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';
import App from './App';
import { ErrorScene } from './game/ErrorScene';
import { GameConfig } from './game/GameConfig';
import { PreloadingScene } from './game/PreloadingScene';
import { WelcomeScene } from './game/WelcomeScene';
import { SpinScene } from './game/SpinScene';

const getPhaserGame = () => {
  dotenv.config();
  let audioContext;
  try {
    // @ts-ignore
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  } catch (e) {
    console.error(e);
  }
  const gameConfig: Phaser.Types.Core.GameConfig = {
    title: 'One-To-Win',

    type: Phaser.AUTO,

    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 750,
      height: 1334,
      parent: 'phaser-game'
    },
    audio: {
      context: audioContext
    },
    physics: {
      default: 'arcade',
      arcade: {
        debug: false
      }
    },

    scene: [PreloadingScene, WelcomeScene, SpinScene, ErrorScene],

    parent: 'phaser-game',
    backgroundColor: '#000000',

    transparent: true
  };

  return new Phaser.Game(gameConfig);
};

window.game = getPhaserGame();
window.model = new GameConfig();

ReactDOM.render(<App />, document.getElementById('one-to-win-app'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
